// extracted by mini-css-extract-plugin
export var attachmentContainer = "_f3-0";
export var fileList = "_f3-2";
export var removeFileButton = "_f3-1";